import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Col, Tooltip } from 'antd';

import { EChargeType } from 'interfaces/IEditProduct';
import type IProduct from 'interfaces/IProduct';

type SectionMoreProps = {
  product: IProduct;
};

function SectionMore({ product }: SectionMoreProps) {
  return (
    <>
      <Col xs={24} md={8}>
        <div className='flex flex-col gap-4 border border-solid border-[#f0f0f0] p-4'>
          <img src='/img/icon_psl.svg' width='40' />
          <strong>Configure o PSL</strong>
          <p>
            Agora você pode configurar os planos para que seus clientes tenham a liberdade e flexibilidade de escolha.
          </p>
          <div>
            <Link id='link-go-to-psl' to={`/producer/product/editproduct/${product.id}/paymentmethods`}>
              <Button>Configurar</Button>
            </Link>
          </div>
        </div>
      </Col>

      <Col xs={24} md={8}>
        <div className='flex flex-col gap-4 border border-solid border-[#f0f0f0] p-4'>
          <img src='/img/icon_offer.svg' width='40' />
          <strong>Crie ofertas</strong>
          <p>Você pode criar ofertas para todos os planos, tornando-os mais atrativos para seus clientes.</p>
          <div>
            <Link id='link-go-to-offer' to={`/producer/product/editproduct/${product.id}/sales`}>
              <Button>Criar oferta</Button>
            </Link>
          </div>
        </div>
      </Col>

      <Col xs={24} md={8}>
        <div className='flex flex-col gap-4 border border-solid border-[#f0f0f0] p-4'>
          <img src='/img/icon_affiliate.svg' width='40' />
          <strong>Comissões para afiliados</strong>
          <p>Configure a porcentagem que seu afiliado receberá por cada plano vendido.</p>
          <div>
            <Tooltip
              placement='top'
              title={
                product.charge_type === EChargeType.FREE
                  ? 'O recurso de afiliado está indisponível para produtos gratuitos'
                  : ''
              }
            >
              <div style={{ display: 'inline-block' }}>
                <Link id='link-go-to-affiliate' to={`/producer/product/editproduct/${product.id}/affiliates`}>
                  <Button disabled={product.charge_type === EChargeType.FREE}>Habilitar comissão</Button>
                </Link>
              </div>
            </Tooltip>
          </div>
        </div>
      </Col>
    </>
  );
}

export default SectionMore;
